import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import TextInput from './TextInput'
import { injectGlobal } from 'styled-components'
import moment from 'moment'

injectGlobal`
  .ott-calendar {
    &.react-datepicker {
      font-family: brother-1816;
      box-shadow: 1px 1px 4px rgba(0,0,0,0.25);
      border: 1px solid #ccc;
      .react-datepicker__triangle {
        border-bottom-color: rgb(162,177,172) !important;
      }
      // .react-datepicker__navigation {
      //   display: none;
      // }
      .react-datepicker__navigation--previous--disabled,
      .react-datepicker__navigation--next--disabled {
        display: none;
      }
    }
    .react-datepicker__header {
      background-color: rgb(162,177,172);
      .react-datepicker__current-month, .react-datepicker__day-name {
        color: white;
      }
    }
    .react-datepicker__day--selected {
      background-color: #ea5329;
    }
  }
`

const DateTextField = (props) => (
  <TextInput style={{ maxWidth: '450px' }} {...props} />
);

class DatePickerComponent extends Component {
  render() {
    return (
      <DatePicker
        // autoFocus="true"
        selected={moment(this.props.value).toDate()}
        dateFormat="yyyy-MM-dd"
        minDate={moment('2020-09-01').toDate()}
        maxDate={moment('2020-10-15').toDate()}
        showDisabledMonthNavigation
        openToDate={moment('2020-09-01').toDate()}
        calendarClassName="ott-calendar"
        onChange={(date) => {
          this.props.onChange({
            target: {
              name: this.props.name,
              value: moment(date).format('YYYY-MM-DD'),
            }
          })
        }}
        customInput={<DateTextField />}
      />
    )
  }
}

export default DatePickerComponent